import { render, staticRenderFns } from "./TrendParagraph.vue?vue&type=template&id=315cb8d3&scoped=true&name=trend-paragraph&"
import script from "./TrendParagraph.vue?vue&type=script&lang=js&"
export * from "./TrendParagraph.vue?vue&type=script&lang=js&"
import style0 from "./TrendParagraph.vue?vue&type=style&index=0&id=315cb8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315cb8d3",
  null
  
)

export default component.exports